/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_InstitutionInputs */

const en_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institution`)
};

const de_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institution`)
};

const fr_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etablissement`)
};

const es_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institucion`)
};

const it_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istituto`)
};

const nl_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instelling`)
};

const pl_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uczelnia`)
};

const fi_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppilaitos`)
};

const da_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institution`)
};

const sv_resume_editor_institution = /** @type {(inputs: Resume_Editor_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Larosate`)
};

/**
* | output |
* | --- |
* | "Institution" |
*
* @param {Resume_Editor_InstitutionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_institution = /** @type {((inputs?: Resume_Editor_InstitutionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_InstitutionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_institution(inputs)
	if (locale === "fr") return fr_resume_editor_institution(inputs)
	if (locale === "es") return es_resume_editor_institution(inputs)
	if (locale === "it") return it_resume_editor_institution(inputs)
	if (locale === "nl") return nl_resume_editor_institution(inputs)
	if (locale === "pl") return pl_resume_editor_institution(inputs)
	if (locale === "fi") return fi_resume_editor_institution(inputs)
	if (locale === "da") return da_resume_editor_institution(inputs)
	if (locale === "sv") return sv_resume_editor_institution(inputs)
	return en_resume_editor_institution(inputs)
});